// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import Element from 'element-ui'
import axios from './http'
import store  from './store/store'
import connection from './utils/utilsSignar'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import echarts from "echarts";
import router from './router'
import globle from './Global'
import IdleVue from "idle-vue";
// import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icons/iconfont.css'
 
 

const eventsHub = new Vue();
Vue.use(Vuex)
Vue.use(connection)
Vue.use(Element)
Vue.use(VueDirectiveImagePreviewer)
// const store = new Vuex.Store({
//   state: {
//     idleVue: {
//       isIdle:false
//     }
//    }
// })
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 900000,
  startAtIdle: false
});
Vue.prototype.$echarts = echarts;
// Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.prototype.LoginInfo = 'USER_INFO';
Vue.prototype.axios = axios;
Vue.prototype._globle = globle;

const vm = this
var count = 0;

function getrefer() {
   
  return document.referrer;
}
router.beforeEach((to, from, next) => {
  // var strs = getrefer();
  // if (localStorage.getItem("isReload")) {
  //   console.log("页面被刷新");
  // } else {
  //   console.log("首次被加载");
  //   localStorage.setItem("isReload", true)
  // }
  // if (from.fullPath == '/' && strs == '') {
  //   count++;
  //   if (count < 10) {
  //     var str = window.localStorage.getItem('USER_INFO')
  //     if (str == null) {
  //       next('/login');
  //       return;
  //     }
  //     window.open('about:blank', '_self').close()
  //     alert("您已打开一个页面");
  //     return;
  //   }
  // }
  const needLogin = to.meta.needLogin
  const screen = to.meta.sr;
  let json = window.localStorage.getItem('USER_INFO')
  let obj = json != null ? JSON.parse(json) : null;
  if (screen) {
    var acc = localStorage.getItem('Terst')
    // if (obj!=null) {
    // //   if (obj.account=='Nestle2020001' || obj.account=='Nestle2020002') {
    // //     next('/customs/err404')
    // // }
    // }
   
  }
  // 判断该路由是否需要登录权限
  if (needLogin) {
 
    if (obj == null) {
      localStorage.clear();
      next('/login');
      return;
    } else {
      // debugger
      // if (from.fullPath == '/' && strs == '' && json != null && localStorage.getItem("isReload") == false) {
      //   next('/login');
      //   return;
      // }
    }
 
    let isLogin = getLoginState(obj.token);
    isLogin.then(function ({
      data
    }) {
      if (data.result) {
   
					
					globle.firstLoginKey = data.data.initialPasswordNotChanged;
        if (vm.connection == null || vm.connection == undefined) {}
        let rolesarr = to.meta.roles
        if (rolesarr != undefined && rolesarr.findIndex(d => d == obj.roleId) > -1) {
          next()
        } else if (rolesarr == undefined) {
          next();
        } else {
          next('/customs/err403')
        }
      } else {
        localStorage.clear();
        next('/login')
      }
    })

  } else {
    next() // 确保一定要有next()被调用
  }
})
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  store,
  template: '<App/>'
})

function getLoginState(token) {


  return axios.get('login/checkSign', {
    headers: {
      'Authorization': token
    }
  });
}

// Vue.config.errorHandler = function (err, vm, info) {
//   console.log(`Error: ${err.toString()}\nInfo: ${info}`);
// }



// WEBPACK FOOTER //
// ./src/main.js